export default [
	{
		path: '/my-account',
		lazy: async () => {
			const Module = await import('../../pages/MyAccount');
			return { Component: Module.default };
		},
	},
];
